<app-page-header></app-page-header>
<app-breadcromb pageName="Applicant Referees"></app-breadcromb>
<!-- Candidate Dashboard Area Start -->
<section class="candidate-dashboard-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-12 dashboard-left-border">
        <div class="dashboard-left">
          <app-client-dashboard-sidebar></app-client-dashboard-sidebar>
        </div>
      </div>
      <div class="col-lg-9 col-md-12">
        <div class="dashboard-right">
          <div class="candidate-profile">
            <div class="candidate-single-profile-info">
              <div class="resume-box">
                <h3>Profile Guide</h3>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="how-works">
                    <div class="how-workimg"><img src="./assets/dist/img/hw1.jpg" alt=""/></div>
                    <div class="how-work-detail">
                      <div class="how-work-box">
                        <span>1</span>
                        <i class="#"></i>
                        <h3>Personal Information</h3>
                        <p>Fill up your personal details.</p>
                      </div>
                    </div>
                  </div>
                  <div class="how-works flip">
                    <div class="how-workimg"><img src="./assets/dist/img/hw1.jpg" alt=""/></div>
                    <div class="how-work-detail">
                      <div class="how-work-box">
                        <span>2</span>
                        <i class="#"></i>
                        <h3>Work Experience </h3>
                        <p>Add your work experience. </p>
                      </div>
                    </div>
                  </div>
                  <div class="how-works">
                    <div class="how-workimg"><img src="./assets/dist/img/hw1.jpg" alt=""/></div>
                    <div class="how-work-detail">
                      <div class="how-work-box">
                        <span>3</span>
                        <i class="#"></i>
                        <h3>Educational Information</h3>
                        <p>Add your educational information.</p>
                      </div>
                    </div>
                  </div>
                  <div class="how-works flip">
                    <div class="how-workimg"><img src="./assets/dist/img/hw1.jpg" alt=""/></div>
                    <div class="how-work-detail">
                      <div class="how-work-box">
                        <span>4</span>
                        <i class="#"></i>
                        <h3>Reference </h3>
                        <p>Add your professional referees. </p>
                      </div>
                    </div>
                  </div>
                  <div class="how-works">
                    <div class="how-workimg"><img src="./assets/dist/img/hw1.jpg" alt=""/></div>
                    <div class="how-work-detail">
                      <div class="how-work-box">
                        <span>5</span>
                        <i class="#"></i>
                        <h3>Uploads</h3>
                        <p>Uploads your certificates.</p>
                      </div>
                    </div>
                  </div>
                  <div class="how-works flip">
                    <div class="how-workimg"><img src="./assets/dist/img/hw1.jpg" alt=""/></div>
                    <div class="how-work-detail">
                      <div class="how-work-box add-two-lines">
                        <span>6</span>
                        <i class="#"></i>
                        <h3>My Profile </h3>
                        <p>You can now view your profile. <br>You can also update any field here! </p>
                      </div>
                    </div>
                  </div>
                  <div class="how-works">
                    <div class="how-workimg"><img src="./assets/dist/img/hw1.jpg" alt=""/></div>
                    <div class="how-work-detail">
                      <div class="how-work-box increase-width add-three-lines">
                        <span>7</span>
                        <i class="#"></i>
                        <h3>Vacancy Application</h3>
                        <!-- <p class="pc">Now you can pick a vacancy and apply. <br>You might be ask to answer few questions before you
                          submit your application. </p> -->
                        <p class="mobile">Now you can pick a vacancy and apply. </p>
                      </div>
                    </div>
                  </div>
                  <div class="how-works flip">
                    <div class="how-workimg"><img src="./assets/dist/img/hw1.jpg" alt=""/></div>
                    <div class="how-work-detail">
                      <div class="how-work-box add-two-lines">
                        <span>8</span>
                        <i class="#"></i>
                        <h3>Dashboard </h3>
                        <p>You can now view your profile statistics under Dashboard. </p>
                      </div>
                    </div>
                  </div>
                  <div class="how-works">
                    <div class="how-workimg"><img src="./assets/dist/img/hw1.jpg" alt=""/></div>
                    <div class="how-work-detail">
                      <div class="how-work-box add-four-lines">
                        <span>9</span>
                        <i class="#"></i>
                        <h3>Manage Jobs</h3>
                        <p>Here you can track the progress of your recent applications. You can also withdrew an
                          application if vacancy is still open and reapply. </p>
                      </div>
                    </div>
                  </div>
                  <div class="how-works flip">
                    <div class="how-workimg"><img src="./assets/dist/img/hw1.jpg" alt=""/></div>
                    <div class="how-work-detail">
                      <div class="how-work-box add-three-lines">
                        <span>10</span>
                        <i class="#"></i>
                        <h3>Change Password </h3>
                        <p>Use this option to change your pass, a password reset link will be sent to your email
                          address. </p>
                      </div>
                    </div>
                  </div>
                  <div style="margin-bottom: 10px;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
<!-- Candidate Dashboard Area End -->
